export default "__VITE_ASSET__45251ab6__"